module.exports = __webpack_public_path__ + "static/media/Logo.0827c6b7.png";